export const ADDRESSES_PATH = '/addresses';
export const IDA_PAGE_LENGTH = 5;
export const STREAMS_PAGE_LENGTH = 20;
export enum ZeroAddresses {
  '0x0000000000000000000000000000000000000000',
  '0x',
}
